<template>
  <div class="w-100 flex b--black-20 br1 ba dim pointer w-100 mw5 textColor">
    <div class="image-container flex items-center justify-center ml-2">
      <img v-if="playlist.picture" class="mw-100 h-100" :src="picture">
    </div>
    <div class="w-100 ph2 flex flex-column justify-center items-start">
      <p class="mv0 fw7 title textColor">{{playlist.title}}</p>
      <p class="mv0 f7 textColor"> {{playlist.trackCount}}
        <span class="textColor">{{ $tc('tracks.track', playlist.trackCount ) }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import consts from '@/consts'
export default {
  name: 'playlist-select',
  props: {
    playlist: {
      required: true
    }
  },
  computed: {
    picture () {
      return consts.MEDIA_BASE_URL + this.playlist.picture
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/variables.scss';

.title {
  white-space: nowrap;
  max-width: 20vw;
  min-width: 20vw;
  width: 20vw;
  overflow: hidden;
  text-overflow: ellipsis;
}
.image-container {
  width: 50px;
  height: 50px;
  max-width: 50px;
  max-height: 50px;
  min-width: 50px;
  min-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/playlists/PlaylistSelect.vue